// import React from 'react';
// import './Footer.css';  // Import the CSS

// const Footer = () => {
//   return (
//     <footer>
//       {/* Top Section: Horizontal Layout */}
//       <div className="footer-top">
//         {/* Our Team Section */}
//         <div className="footer-item">
//           <div><strong>OUR TEAM</strong></div>
//           <div>Initiatives for Alumni</div>
//           <div>Institute Facilities</div>
//           <div>Privacy Policy</div>
//         </div>
        
//         {/* Navigation Section */}
//         <div className="footer-item">
//           <div><strong>NAVIGATION</strong></div>
//           <div>Home</div>
//           <div>News & Updates</div>
//           <div>Reunions</div>
//           <div>Community & Events</div>
//         </div>
        
//         {/* Contact Us Section */}
//         <div className="footer-item">
//           <div><strong>CONTACT US</strong></div>
//           <div>
//             <i className="fa-solid fa-location-dot"></i>AU - Block (Outer Ring<br></br>Road) Pitampura, Delhi - 110034
//           </div>
//           <div>
//             <i className="fa-solid fa-envelope"></i>vse.vips@gmail.com
//           </div>
//         </div>
//         {/* Social Media Section */}
//         <div className="footer-item">
//           <div className="social-icons">
//             <a href="https://www.linkedin.com/company/alumni-relations-committee-vse-vipstc/" target="_blank" rel="noopener noreferrer">
//               <i className="fab fa-linkedin"></i>
//             </a>
//             <a href="https://www.instagram.com/arc.vse/?igsh=MWtlNzRkZnc1dDN4aw%3D%3D" target="_blank" rel="noopener noreferrer">
//               <i className="fab fa-instagram"></i>
//             </a>
//           </div>
//         </div>
//       </div>
//        {/* Copyright Section */}
//        <div className="footer-copyright">
//         <span className="copyright-grey">&copy;Copyright 2023, </span>
//         <span className="copyright-white">ALUMNI RELATIONS COMMITTEE, VIPS</span>
//       </div>
//     </footer>
//     );
// };

// export default Footer;


import React from 'react';
import './Footer.css';  // Import the CSS
import { Link } from 'react-router-dom';

const handleClick = () => {
  window.scrollTo(0, 0);
};

const Footer = () => {
  return (
    <footer>
      {/* Top Section: Horizontal Layout */}
      <div className="footer-top">
        {/* Our Team Section */}
        <div className="footer-item">
          <div><strong>OUR TEAM</strong></div>
          <div><a href="https://vips.edu/">Visit Us</a></div>
          <div><Link to="/pages/faculty" onClick={handleClick}>VSE Faculty</Link></div>
          {/* <div>Privacy Policy</div> */}
        </div>
        
        {/* Navigation Section */}
        <div className="footer-item">
          <div><strong>NAVIGATION</strong></div>
          {/* <div> <Link to="/">Home</link></div> */}
          <div> <Link to="/">Home</Link></div>
          <div> <Link to="/pages/alumni-container">Alumni</Link></div>
          <div><Link to="/pages/student-dashboard">Students</Link></div>
          <div><Link to="/pages/media-page">Community & Events</Link></div>
        </div>
        
         {/* Contact Us Section */}
         <div className="footer-item">
          <div><strong>CONTACT US</strong></div>
          <div>
            {/* Link to Google Maps */}
            <a 
              href="https://www.google.com/maps/place/Vivekananda+Institute+of+Professional+Studies/@28.7195793,77.1402553,16.54z/data=!4m6!3m5!1s0x390d0170e8096b31:0x9a906c658b08a033!8m2!3d28.7212832!4d77.1417703!16s%2Fm%2F05h1rcy?entry=ttu&g_ep=EgoyMDI1MDEyMS4wIKXMDSoASAFQAw%3D%3D"
              target="_blank" 
              rel="noopener noreferrer"
            >
              <i className="fa-solid fa-location-dot"></i>
              AU - Block (Outer Ring Road) Pitampura, Delhi - 110034
            </a>
          </div>
          <div>
            {/* Link to open email client */}
            <a href="mailto: arc.vse.24@gmail.com">
              <i className="fa-solid fa-envelope"></i>arc.vse.24@gmail.com
            </a>
          </div>
        </div>

        {/* Social Media Section */}
        <div className="footer-item">
          <div className="social-icons">
            <a href="https://www.linkedin.com/company/alumni-relations-committee-vse-vipstc/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://www.instagram.com/arc.vse/?igsh=MWtlNzRkZnc1dDN4aw%3D%3D" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>
       {/* Copyright Section */}
       <div className="footer-copyright">
        <span className="copyright-grey">&copy;Copyright 2023, </span>
        <span className="copyright-white">ALUMNI RELATIONS COMMITTEE, VIPS</span>
      </div>
    </footer>
    );
};

export default Footer;